import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/src/components/container/container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Counter"] */ "/var/www/SOC/src/components/counter/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/src/components/section-heading/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/var/www/SOC/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSection"] */ "/var/www/SOC/src/sections/about/v1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/var/www/SOC/src/sections/contact/v1/form/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/var/www/SOC/src/sections/hero/v1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerSection"] */ "/var/www/SOC/src/sections/partner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectSection"] */ "/var/www/SOC/src/sections/project/v2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceCardsCaraousl"] */ "/var/www/SOC/src/sections/service/v3/cards-carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionCardsCaraousl"] */ "/var/www/SOC/src/sections/solution/cards-carousel/index.tsx");
